<template>
  <div id="app">
    <div class="contBox" v-if="this.$router.currentRoute.path !== '/loginRe'">
      <div class="loginBoxHearder">
        <div class="menuBox" @mouseenter="menuboxEnter" @mouseleave="menuboxLeave">
          <img class="titlelogo" @click="golink('index')" src="./assets/titlelogo.png" />
          <el-menu default-active="" class="el-menu-demo" mode="horizontal" background-color="transparent"
            text-color="#ffffff" active-text-color="#ffffff">
            <el-menu-item @click="golink('index')">
              <span slot="title">做单</span>
            </el-menu-item>

            <el-menu-item @click="golink('myReceiveResume')">
              <span slot="title">AI简历</span>
            </el-menu-item>
            <el-menu-item @click="aimessage()">
              <span slot="title">AI问答</span>
            </el-menu-item>
            <el-menu-item @click="showgzpos()">
              <span slot="title">关注的职位</span>
            </el-menu-item>
            <el-menu-item @click="golink('workroom')">
              <span slot="title">工作台</span>
            </el-menu-item>
            <el-menu-item @click="golink('my')">
              <span slot="title">我的</span>
            </el-menu-item>
          </el-menu>
          <img class='avater' :src="userStatus.avatarPath" v-if="!userStatus.adminToken" />
        </div>
      </div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
      <div class="kfbox" @click="openkef()" ><i class="el-icon-s-custom"></i><span>客</span><span>服</span></div>
      <el-dialog
        title="扫码添加客服微信"
        :visible.sync="dialogVisible2"
        width="30%"
        >
        <img src="./assets/kf.jpg"  style="width: 70%;margin: 0 auto;display: block;"/>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
        </span>
      </el-dialog>

    </div>
    <div v-if="this.$router.currentRoute.path === '/loginRe'">
      <div class="contBox">
        <router-view />
      </div>
    </div>


    <el-drawer title="简历中心" :modal="false" :modal-append-to-body="false" :visible.sync="drawer" :direction="'rtl'"
      size="100%">

      <div class="jlzxbox">
        <div class="bt11">所有候选人<el-button type="primary" @click="goupload">前往上传简历</el-button></div>

        <el-table :data="jlLIst" style="width: 100%" height="60vh">
          <el-table-column fixed prop="name" label="姓名" width="150">
          </el-table-column>
          <el-table-column prop="sex" label="性别" width="120">
          </el-table-column>
          <el-table-column prop="age" label="年龄" width="120">
          </el-table-column>
          <el-table-column prop="education" label="学历" width="120">
          </el-table-column>
          <el-table-column prop="workingLifeMax" label="工作经验" width="300">
          </el-table-column>
          <el-table-column prop="nowJob" label="最近职位" width="120">
          </el-table-column>
          <el-table-column prop="nowCompany" label="最近公司" width="120">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="420">
            <template slot-scope="scope">
              <el-button @click="deleteRes(scope.row)" type="danger">删除</el-button>
              <el-button @click="goltbg(scope.row)" type="primary"> <i class="el-icon-download"></i> 生成猎头报告</el-button>
              <el-button @click="goyh(scope.row)" type="primary"> <i class="el-icon-s-opportunity"></i> 优化简历</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-empty v-if="jlLIst.length <= 0" description="暂无简历"></el-empty>
        <el-pagination style="margin: 30px auto 0 auto; text-align: center;" @current-change="getResList"
          :current-page.sync="pageNumber" :page-size.sync="pageSize" layout="total, prev, pager, next, jumper" :total="pagetotal">
        </el-pagination>
      </div>
    </el-drawer>


    <el-drawer title="AI问答" :modal="false" :modal-append-to-body="false" :visible.sync="drawer1" :direction="'rtl'">
      <div class="scbox">

        <el-card class="box-card1" id="box-card1" style="width: 100%">
          <div v-for="(item, index) in twlist" :key="index" class="tbox">
            <div class="myinfo">
              <div class="name">
                {{ userStatus.nickname }}
              </div>
              <div class="textbox">
                {{ item.text }}
              </div>
            </div>
            <div class="gptinfo">
              <div class="name">
                聘小快
              </div>
              <div class="textbox">
                {{ item.state === 'success' ? item.res : '正在回答中' }}
              </div>
            </div>
          </div>
        </el-card>
        <div class="twbox">
          <el-input placeholder="请输入你的问题" v-model="tw">
          </el-input>
          <el-button class="scbtn" type="primary" @click="getTw()">提问</el-button>
        </div>
      </div>
    </el-drawer>

    <el-drawer title="关注的职位" :modal="false" :modal-append-to-body="false" :visible.sync="drawer5" :direction="'rtl'">
      <ul class="infinite-list" style="overflow:auto">
        <li v-for="(item, key) in list5" :key="key" class="infinite-list-item" style="margin-top: 20px; padding: 0 20px;">
          <el-descriptions :column="2" border>
            <el-descriptions-item labelStyle="width: 75px" contentStyle="width: 200px" label="职位名">{{ item.name }}</el-descriptions-item>
            <el-descriptions-item label="操作">
              <el-button @click="gopos(item)" type="danger">查看职位</el-button>
            </el-descriptions-item>
          </el-descriptions>
        </li>
      </ul>
      <el-empty v-if="list5.length <= 0" description="暂无关注职位"></el-empty>
    </el-drawer>


    <el-drawer title="投递记录" :modal="false" :modal-append-to-body="false" :visible.sync="drawer6" :direction="'rtl'" :wrapperClosable="true"  :close-on-press-escape="true">
      <div class="ggg">
        <el-form>
          <el-form-item label="类型">
            <el-radio-group @input="goChange" v-model="jobPublishStatus">
              <el-radio label="1">待处理 ({{ jobstaticArray[0].statusNum}})</el-radio>
              <el-radio label="4">已面试 ({{ jobstaticArray[3].statusNum }})</el-radio>
              <el-radio label="5">已发offer ({{ jobstaticArray[4].statusNum }})</el-radio>
              <el-radio label="6">已入职 ({{ jobstaticArray[5].statusNum }})</el-radio>
              <el-radio label="7">已过保 ({{ jobstaticArray[6].statusNum }})</el-radio>
              <el-radio label="100">被淘汰</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <ul class="infinite-list" v-infinite-scroll="load6" style="overflow:auto">
        <li v-for="(item, key) in list6" :key="key" class="infinite-list-item" style="margin-top: 20px; padding: 0 20px;">
          <el-descriptions :column="2" border>
            <el-descriptions-item label="姓名">{{ item.name }}</el-descriptions-item>
            <el-descriptions-item label="投递职位">{{ item.positionName }}</el-descriptions-item>
            <el-descriptions-item label="投递公司">{{ item.companName }}</el-descriptions-item>
            <el-descriptions-item label="结果">

              {{ Number(item.deliverStatus) === 1 ? '简历已投递至平台审核' : '' }}
              {{ Number(item.deliverStatus) === 3 ? '该简历审核未通过' : '' }}
              {{ Number(item.deliverStatus) === 3 &&
                item.deliverDesc &&
                item.deliverDesc !== '' ?
                `未通过原因：${item.deliverDesc}` : ''
              }}
              {{ Number(item.adminStatus) === 1 &&
                Number(item.deliverStatus) === 2 &&
                Number(item.entryPersonStatus) === 1 ?
                '该简历已通过平台审核，投递至HR' : ''
              }}
              {{ Number(item.adminStatus) === 1 &&
                Number(item.deliverStatus) === 2 &&
                Number(item.entryPersonStatus) === 2 ?
                'HR将该简历标记为已入职' : ''
              }}
              {{ Number(item.adminStatus) === 1 &&
                Number(item.deliverStatus) === 2 &&
                Number(item.entryPersonStatus) === 3 ?
                'HR将该简历标记为已面试' : ''
              }}
              {{ Number(item.adminStatus) === 1 &&
                Number(item.deliverStatus) === 2 &&
                Number(item.entryPersonStatus) === 4 ?
                'HR将该简历标记为已发Offer' : ''
              }}
              {{ Number(item.adminStatus) === 2 &&
                Number(item.paymentStatus) === 1 ?
                '候选人已入职,待保质期过，企业支付佣金' : ''
              }}
              {{ Number(item.adminStatus) === 2 &&
                Number(item.paymentStatus) === 2 &&
                Number(item.paymentStatus) === 1 ?
                '候选人已入职,首付款已收款，尚未结算' : ''
              }}
              {{ Number(item.adminStatus) === 2 &&
                Number(item.paymentStatus) === 2 &&
                Number(item.paymentStatus) === 2 ?
                '候选人已入职,首付款已收款，首付款已结算' : ''
              }}
              {{ Number(item.adminStatus) === 2 &&
                Number(item.paymentStatus) === 3 &&
                Number(item.paymentStatus) === 2 ?
                '候选人已入职,尾款已收款，尚未结算' : ''
              }}
              {{ Number(item.adminStatus) === 2 &&
                Number(item.paymentStatus) === 3 &&
                Number(item.paymentStatus) === 2 ?
                '候选人已入职,尾款已收款，首付款已结算' : ''
              }}
              {{ Number(item.adminStatus) === 2 &&
                Number(item.paymentStatus) === 3 &&
                Number(item.paymentStatus) === 2 ?
                '候选人已入职' : ''
              }}



            </el-descriptions-item>
          </el-descriptions>
        </li>
      </ul>
      <el-empty v-if="list6.length <= 0" description="暂无投递记录"></el-empty>
    </el-drawer>




  </div>
</template>
  
<script>
!(function (t) {
  function e() {
    var e = this || self
      ; (e.globalThis = e), delete t.prototype._T_
  }
  'object' != typeof globalThis &&
    (this
      ? e()
      : (t.defineProperty(t.prototype, '_T_', {
        configurable: !0,
        get: e,
      }),
        _T_))
})(Object)

import axios from 'axios'
import Config from './config/index'
import moment from 'moment'
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import { Message } from 'element-ui'


function loadFile(url, callback) {
  PizZipUtils.getBinaryContent(url, callback);
}



export default {
  name: 'app',
  components: {},
  data() {
    return {
      jobstaticArray: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      userStatus: this.$store.state.userStatus,
      isCollapse: true,
      drawer: false,
      jlLIst: [],
      pageSize: 15,
      pageNumber: 1,
      pagetotal: 0,
      jobinfo: false,
      resinfo: false,
      getResTagInfo: false,
      restagid: false,
      drawer1: false,
      twinfo: false,
      twlist: [],
      tw: '',
      drawer5: false,
      drawer6: false,
      list5: [],
      pageSize5: 15,
      pageNumber6: 1,
      pagetotal6: 0,
      list6: [],
      pageSize5: 15,
      pageNumber6: 1,
      pagetota6: 0,
      jobPublishStatus: '1',
      dialogVisible2: false
    }
  },
  computed: {
    userStatusfunc() {
      return this.$store.state.userStatus
    },
  },
  watch: {
    userStatusfunc(val) {
      this.userStatus = val
    },
    $route(to, from) {
      if (!localStorage.getItem('token') && (to.name !== 'index' && to.name !== 'job' && to.name !== 'loginRe')) {
        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
      }
    },
  },
  created: function () {
    if (!localStorage.getItem('token') && (this.$route.name !== 'index' && this.$route.name !== 'job' && this.$route.name !== 'loginRe')) {
      window.location.href = 'https://www.pinkuaikuai.cn/login.html'
    }
    this.stopF5Refresh();
  },
  methods: {
    stopF5Refresh() {
      // document.onkeydown = function (e) {
      //   var evt = window.event || e;
      //   var code = evt.keyCode || evt.which;
      //   //屏蔽F1---F12
      //   if (code > 111 && code < 124) {
      //     if (evt.preventDefault) {
      //       evt.preventDefault();
      //     } else {
      //       evt.keyCode = 0;
      //       evt.returnValue = false;
      //     }
      //   }
      // };
      // //禁止鼠标右键菜单
      // document.oncontextmenu = function () {
      //   return false;
      // };
      //阻止后退的所有动作，包括 键盘、鼠标手势等产生的后退动作。
      history.pushState(null, null, window.location.href);
      window.addEventListener("popstate", function () {
        history.pushState(null, null, window.location.href);
      });
    },
    openkef () {
      this.dialogVisible2 = true
    },
    golink: function (link) {
      this.$router.push({
        name: link,
      })
    },
    menuboxEnter() {
      this.isCollapse = false
    },
    menuboxLeave() {
      this.isCollapse = true
    },
    goupload: function () {
      this.drawer = false
      this.$router.push({
        name: 'upload',
      })
    },
    gopos: function (item) {
      this.$router.push({
        name: 'job',
        params: { id: item.code }
      })
      location.reload()
    },
    showgzpos: function () {
      if (!localStorage.getItem('token')) {
        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
      } else {
        this.pageNumber5 = 1
        this.pagetotal5 = 0
        this.drawer5 = true
        this.getgzList()
      }
    },
    getgzList: function () {
      let that = this
      that.loading = true
      let data = {
        type: '3'
      }
      axios({
        method: 'POST',
        url: Config.path + '/api/candidate/getFollow',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: data,
      })
        .then((res) => {
          

          that.loading = false
          if (res.data.success === '1') {
            let demoList = []
            if (res.data.content !== undefined && res.data.content !== null) {
              demoList = res.data.content
              that.list5 = demoList
            } else {
              that.list5 = []
            }
          } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    showtdjl: function () {
      if (!localStorage.getItem('token')) {
        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
      } else {
        this.pageNumber6 = 1
        this.pagetotal6 = 0
        this.drawer6 = true
        this.gettdList()
        this.getGztInfo()
      }
    },
    load6: function () {
      if (this.list6.length < this.pagetotal6) {
        this.pageNumber6 = this.pageNumber6 + 1
        this.gettdList()
      }
    },
    goChange: function () {
      this.pageNumber6 = 1
      this.pagetotal6 = 0
      this.gettdList()
    },
    gettdList: function () {
      let that = this
      that.loading = true
      let data = {
        pageSize: 15,
        pageNum: that.pageNumber6,
        jobPublishStatus: Number(that.jobPublishStatus)
      }
      axios({
        method: 'POST',
        url: Config.path + '/api/candidate/myUpResumeList',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: data,
      })
        .then((res) => {
          

          that.loading = false
          if (res.data.success === '1') {
            let demoList = []
            if (that.pageNumber6 === 1) {
              demoList = res.data.content.list
            } else {
              demoList = dataList.concat(res.data.content.list)
            }
            that.pagetotal6 = res.data.content.total
            that.list6 = demoList
          } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    showUploadRes: function () {
      if (!localStorage.getItem('token')) {
        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
      } else {
        this.pageNumber = 1
        this.pagetotal = 0
        this.drawer = true
        this.getResList()
      }
    },
    aimessage: function () {
      if (!localStorage.getItem('token')) {
        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
      } else {
        this.drawer1 = true
      }
    },
    load: function () {
      if (this.jlLIst.length < this.pagetotal) {
        this.pageNumber = this.pageNumber + 1
        this.getResList()
      }
    },
    getResList: function () {
      let that = this
      that.loading = true
      let data = {
        pageSize: that.pageSize,
        pageNum: that.pageNumber
      }
      axios({
        method: 'POST',
        url: Config.path + '/api/candidate/myResumeList',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: data,
      })
        .then((res) => {
          that.loading = false
          if (res.data.success === '1') {
            let demoList = []
            demoList = res.data.content.list
            that.pagetotal = res.data.content.total
            that.jlLIst = demoList
          } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    deleteRes: function (item) {
      let that = this
      that.loading = true
      this.$confirm('确认删除该简历？')
        .then(_ => {
          let data = {
            id: item.id
          }
          axios({
            method: 'POST',
            url: Config.path + '/api/candidate/delResume',
            headers: {
              token: localStorage.getItem('token'),
              'content-type': 'application/json',
            },
            data: data,
          })
            .then((res) => {
              that.loading = false
              if (res.data.success === '1') {
                that.pageNumber = 1
                that.pagetotal = 0
                that.getResList()
              } else {
                that.$message.error(res.data.message)
              }
            })
            .catch((err) => {
              that.loading = false
              that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
            })
        })
        .catch(_ => { });
    },
    goltbg: function (item) {
      let that = this
      this.loading = true
      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')
      

      var urlencoded = new URLSearchParams()
      urlencoded.append('pkkresid', item.id)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getlinkpkk', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          that.loading = false
          let res = JSON.parse(result).msg
          if (res === undefined) {
            that.$message.error('请重新上传此简历')
            return false
          }
          

          that.resinfo = res
          that.getResTag()
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    getResTag: function () {
      this.$message({
        message: '正在努力读取中',
        type: 'warning',
        duration: 0,
      })
      let that = this
      this.loading = true

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append(
        'resinfo',
        `年龄：${that.resinfo.basic_info.age ? that.resinfo.basic_info.age + '岁' : ''
        }，学历：${that.resinfo.basic_info.degree}，工作年限：${that.resinfo.basic_info.num_work_experience
        }，`
      )
      urlencoded.append('id', that.resinfo._id)
      urlencoded.append(
        'resinfo1',
        `职位名称：${that.resinfo.work_experience[0].job_title},在职时间：${that.resinfo.work_experience[0].start_time_year} ~ ${that.resinfo.work_experience[0].end_time_year},工作简介：${that.resinfo.work_experience[0].description}，`
      )
      urlencoded.append(
        'resinfo2',
        that.resinfo.work_experience.length > 1
          ? `职位名称：${that.resinfo.work_experience[1].job_title},在职时间：${that.resinfo.work_experience[1].start_time_year} ~ ${that.resinfo.work_experience[1].end_time_year},工作简介：${that.resinfo.work_experience[1].description}，`
          : 'null'
      )
      urlencoded.append('user', localStorage.getItem('token'))

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getResTag', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          Message.closeAll()
          that.loading = false
          console.log(result)
          let posres = JSON.parse(result).msg
          that.restagid = posres
          that.getResTagById(posres)

        })
        .catch((error) => {
          Message.closeAll()
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    getResTagById: function (id) {
      let that = this

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append('user', localStorage.getItem('token'))
      urlencoded.append('id', id)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getResTagById', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          console.log(result)
          let posresg = JSON.parse(result).msg
          that.getResTagInfo = posresg
          

          if (!posresg.res || posresg.res && posresg.res === '') {
            that.getResTagById(id)
          } else {
            that.createLtDoc()
          }
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    createLtDoc: function () {
      this.$message({
        showClose: true,
        message: '数据下载完毕，正在生成报告中'
      });
      let resinfo = this.resinfo
      let that = this
      let filename = '/lietoubaogaoDemo.docx'
      loadFile(filename, function (
        error,
        content
      ) {
        

        if (error) {
          throw error;
        }
        

        var zip = new PizZip(content);
        

        var doc = new Docxtemplater(zip, {
          paragraphLoop: true,
          linebreaks: true
        });
        

        let data = {
          AI_text: that.getResTagInfo.res === "" ? "_____" : that.getResTagInfo.res,
          realname: resinfo.basic_info.name === "" ? "_____" : resinfo.basic_info.name,
          age: resinfo.basic_info.age === "" ? "_____" : resinfo.basic_info.age,
          sex: resinfo.basic_info.gender === "" ? "_____" : resinfo.basic_info.gender,
          hunpei: "_____",
          address: "_____",
          phone: resinfo.contact_info.phone_number === "" ? "_____" : resinfo.contact_info.phone_number,
          email: resinfo.contact_info.email === "" ? "_____" : resinfo.contact_info.email,
          edu_history: '',
          work_history: '',
          project_info: ''
        }
        let education_experience = resinfo.education_experience
        let edutext = ''
        for (let i in education_experience) {
          edutext += `${education_experience[i].start_time_year}.${education_experience[i].start_time_month}-${education_experience[i].end_time_year}.${education_experience[i].end_time_month}     ${education_experience[i].school_name}     ${education_experience[i].major}     ${education_experience[i].degree}\n\n`
        }
        data.edu_history = edutext
        let work_experience = resinfo.work_experience
        let worktext = ''
        for (let i in work_experience) {
          worktext += `${work_experience[i].start_time_year}.${work_experience[i].start_time_month}-${work_experience[i].end_time_year === "" ? "_" : work_experience[i].end_time_year}.${work_experience[i].end_time_month === "" ? "_" : work_experience[i].end_time_month}     ${work_experience[i].company_name}\n职位:${work_experience[i].job_title}\n工作职责:\n${work_experience[i].description}\n\n\n`
        }
        data.work_history = worktext
        let project_experience = resinfo.project_experience
        let projecttext = ''
        for (let i in project_experience) {
          projecttext += `${project_experience[i].start_time_year}.${project_experience[i].start_time_month}-${project_experience[i].end_time_year === "" ? "_" : project_experience[i].end_time_year}.${project_experience[i].end_time_month === "" ? "_" : project_experience[i].end_time_month}     ${project_experience[i].project_name}\n项目职责:\n${project_experience[i].description}\n\n\n`
        }
        data.project_info = projecttext
        

        doc.setData(data);
        try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render();

        } catch (error) {
          

          console.log(JSON.stringify({ error: error }, that.replaceErrors));
          if (error.properties && error.properties.errors instanceof Array) {
            const errorMessages = error.properties.errors
              .map(function (error) {
                return error.properties.explanation;
              })
              .join('\n');
            console.log('errorMessages', errorMessages);
          }
          throw error;
        }
        var out = doc.getZip().generate({
          type: 'blob',
          mimeType:
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });
        saveAs(out, `聘快快推荐报告 ${resinfo.basic_info.name}.docx`);
      });
    },
    goyh: function (item) {

      let that = this
      this.loading = true
      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')
      

      var urlencoded = new URLSearchParams()
      urlencoded.append('pkkresid', item.id)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getlinkpkk', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          that.loading = false
          let res = JSON.parse(result).msg
          if (res === undefined) {
            that.$message.error('请重新上传此简历')
            return false
          }
          

          that.drawer = false
          that.$router.push({
            name: 'ai',
            params: { id: item.id }
          })
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    getTwList: function () {
      let that = this
      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append('user', localStorage.getItem('token'))

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch('https://api.qilinpin.cn/gptapi/api/getTwList', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          let res = JSON.parse(result).msg
          that.twlist = res
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    getTw: function () {
      let that = this
      if (this.tw === '') {
        this.$message({
          message: '请输入你的问题',
          type: 'warning',
        })
      } else {
        this.loading = true

        var myHeaders = new Headers()
        myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

        var urlencoded = new URLSearchParams()
        urlencoded.append('text', this.tw)
        urlencoded.append('user', localStorage.getItem('token'))

        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow',
        }

        fetch(' https://api.qilinpin.cn/gptapi/api/getTw', requestOptions)
          .then((response) => response.text())
          .then((result) => {
            that.loading = false
            let res = JSON.parse(result).msg
            that.twinfo = res
            that.tw = ""
          })
          .catch((error) => {
            that.loading = false
            that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
            console.log('error', error)
          })
      }
    },
    getGztInfo: function () {
            let that = this
            that.loading = true
            let data = { pageSize: 200, pageNum: 1 }
            axios({
                method: 'POST',
                url: Config.path + '/api/candidate/countJobStatusByJobId',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json',
                },
                data: data
            })
                .then((res) => {
                    that.loading = false
                    if (res.data.success === '1') {
                        that.jobstaticArray = res.data.content
                    } else {
                        that.$message.error(res.data.message)
                    }
                })
                .catch((err) => {
                    that.loading = false
                    that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                })
        },
  },
  mounted: function () {

    setInterval(() => {
      if (!localStorage.getItem('token')) {

      } else {
        this.getTwList()
      }
    }, 1500)



  },
}
</script>
  
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

#app {
  background-image: url('./assets/bg.png');
  background-attachment: fixed;
  background-size: 100% auto;
  min-height: 100vh;
  // width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;

  .kfbox{
    background-color: #5DC2D0;
    position: fixed;
    right: 0;
    top: 70%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    padding: 20px 10px;
    cursor: pointer;
    border-radius: 5px;
  }

  .menuBox {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    .el-menu {
      border: none;
      border-radius: 8px;

      .el-menu-item {
        i {
          color: #ffffff;
        }
      }

      .is-active {
        background-color: transparent !important;

        i {
          color: #ffffff;
        }
      }
    }
  }

  .contBox {
    width: 100%;
    flex: 1;
    min-height: 100vh;
    // border-radius: 20px 20px 0 0;
    background-color: #e6e6e6;
    box-shadow: 0 0 15px rgba($color: #757575, $alpha: 0.75);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    position: relative;

    .loginBoxHearder {
      width: 100%;
      height: 123px;
      background-image: url('./assets/headerBg.png');
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .titlelogo {
        width: 216px;
        height: 67.8px;
        margin-left: 35.6px;
        margin-right: 132px;
      }
    }
  }

  .avater {
    border-radius: 100%;
    width: 65px;
    display: block;
    position: absolute;
    right: 46px;
    top: 29px;
  }

  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #5DC2D0;
  }

  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #5DC2D0;
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #5DC2D0;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #5DC2D0;
  }
}

input::-webkit-input-placeholder {
  color: '#5DC2D0';
}

.scbox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .box-card1 {
    height: 60vh;
    overflow-y: scroll;
    display: flex;
    flex-direction: column-reverse;
  }

  .tbox {

    .myinfo {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-end;

      .name {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-start;
      }

      .textbox {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        width: 70%;
        background-color: #b7deed;
        padding: 20px 15px;
        border-radius: 5px;
        margin-top: 10px;
      }
    }

    .gptinfo {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      .name {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
      }

      .textbox {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        width: 70%;
        background-color: #b7deed;
        padding: 20px 15px;
        border-radius: 5px;
        margin-top: 10px;
      }
    }
  }

  .twbox {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 20px 0 0 0;

    .scbtn {
      margin: 0;
    }
  }

  .scbtn {
    margin-top: 50px;
  }




}

.el-drawer__wrapper {
  .el-drawer__body {
    .ggg {
      width: 90%;
      margin: 0 auto;

      .el-form {
        .el-form-item {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: flex-start;
          margin-bottom: 10px;

          .el-form-item__label {
            width: 160px;
            text-align: left;
            line-height: 40px;
          }

          .el-form-item__content {
            flex: 1;

            .el-radio-group {
              .el-radio {
                line-height: 40px;
                margin: 0px 20px 10px 0px;
              }
            }
          }
        }
      }
    }
  }
}

.bt11 {
  width: 100%;
  font-size: 20px;
  font-weight: bold;
  padding-left: 20px;
  height: 50px;
  line-height: 50px;
  border-left: 5px solid #5dc1cf;
  margin-bottom: 30px;
  margin-top: 30px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .btn {
    cursor: pointer;
    width: 120px;
    height: 36px;
    font-size: 18px;
    line-height: 36px;
    border-radius: 36px;
    background-color: #5dc1cf;
    color: #ffffff;
    text-align: center;
  }
}
</style>
  